/**
 * Created by XuQiang on 2017/5/25.
 */
import React from 'react';
import '../style/404.css';
import { Link } from 'dva/router';
import { FormattedMessage } from 'react-intl';

const bg = require('../assets/sandishu.png');

export default () => {
  return (
    <div className="containe">
      <div className="pic">
        <img src={bg} />
      </div>
      <h2>
        <FormattedMessage id="error_404" />
      </h2>
      <p>
        <FormattedMessage id="error_tips" />
      </p>
      <Link to="/" className="btn">
        <FormattedMessage id="back_index" />
      </Link>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/routes/Undefined.js